import { render, staticRenderFns } from "./areaCascaderMultiple.vue?vue&type=template&id=8b4c292a"
import script from "./areaCascaderMultiple.vue?vue&type=script&lang=js"
export * from "./areaCascaderMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports